var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLayers = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6857 1.56903C11.8851 1.47699 12.1149 1.47699 12.3143 1.56903L22.0643 6.06903C22.3299 6.19162 22.5 6.45746 22.5 6.75C22.5 7.04254 22.3299 7.30838 22.0643 7.43097L12.3143 11.931C12.1149 12.023 11.8851 12.023 11.6857 11.931L1.93571 7.43097C1.67009 7.30838 1.5 7.04254 1.5 6.75C1.5 6.45746 1.67009 6.19162 1.93571 6.06903L11.6857 1.56903ZM4.03973 6.75L12 10.424L19.9603 6.75L12 3.07603L4.03973 6.75ZM1.56903 16.9357C1.74261 16.5596 2.1882 16.3954 2.56429 16.569L12 20.924L21.4357 16.569C21.8118 16.3954 22.2574 16.5596 22.431 16.9357C22.6045 17.3118 22.4404 17.7574 22.0643 17.931L12.3143 22.431C12.1149 22.523 11.8851 22.523 11.6857 22.431L1.9357 17.931C1.55962 17.7574 1.39545 17.3118 1.56903 16.9357ZM2.56429 11.319C2.1882 11.1454 1.74261 11.3096 1.56903 11.6857C1.39545 12.0618 1.55962 12.5074 1.9357 12.681L11.6857 17.181C11.8851 17.273 12.1149 17.273 12.3143 17.181L22.0643 12.681C22.4404 12.5074 22.6045 12.0618 22.431 11.6857C22.2574 11.3096 21.8118 11.1454 21.4357 11.319L12 15.674L2.56429 11.319Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLayers);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/layers.206e73c8a1bdf0602c1769b314f503cc.svg";